// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetTextContentPagedListRequestModel from '../../model/get-text-content-paged-list-request-model';
import GetTextContentPagedListRequestDTO from '../dto/get-text-content-paged-list-request-dto';
import dtoSchema from '../schemas/get-text-content-paged-list-request-schema';

export default abstract class GetTextContentPagedListRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetTextContentPagedListRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.scope = data.scope;
      this.language = data.language;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  */
  scope?: string;
  /**
  */
  language?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetTextContentPagedListRequestDTO>): GetTextContentPagedListRequestModel;
  static toModel(dto: DeepPartial<GetTextContentPagedListRequestDTO> | undefined | null): GetTextContentPagedListRequestModel | undefined;
  static toModel(dto: DeepPartial<GetTextContentPagedListRequestDTO> | undefined | null): GetTextContentPagedListRequestModel | undefined {
    return dto ? new GetTextContentPagedListRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetTextContentPagedListRequestModel> | GetTextContentPagedListRequestModel): GetTextContentPagedListRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      scope: unwrapped.scope,
      language: unwrapped.language,
      searchCriteria: unwrapped.searchCriteria,
    } as GetTextContentPagedListRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetTextContentPagedListRequestModel, can not map to GetTextContentPagedListRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
